export const LINK_CREATED = 'link-created';